import type { IconProps } from './types';
import './icons.css';

export default function Chat({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-chat ${className || ''}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        d="M16.625 14.375h-6.25l-3.75 2.5v-2.5h-2.5c-.69 0-1.25-.56-1.25-1.25v-10c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25Z"
      />
      <path
        stroke="currentColor"
        d="M7.5 8.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM11 8.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM15 8.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
      />
    </svg>
  );
}
